import { createContext, type PropsWithChildren, useContext, type ReactElement } from 'react';
import { useSapaChat } from '../hooks/useSapaChat';
import { type SapaChatContextType } from './types';

const SapaChatContext = createContext<SapaChatContextType | undefined>(undefined);

export const SapaChatProvider = ({ children }: PropsWithChildren): ReactElement => {
  const sapaChatData = useSapaChat();

  return <SapaChatContext.Provider value={sapaChatData}>{children}</SapaChatContext.Provider>;
};

export const useSapaChatContext = (): SapaChatContextType => {
  const context = useContext(SapaChatContext);
  if (context === undefined) {
    throw new Error('useSapaChatContext must be used within a SapaChatProvider');
  }
  return context;
};
